<template>

	<v-content>
		<v-container fluid fill-height> 
			<v-layout row wrap>
				<v-flex xs12 sm6 offset-sm3>
					<v-card>
						<template v-if="isLoading">
							<div class="text-xs-center pa-5">
								<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
								<div class="caption mt-4">Liste yükleniyor</div>
							</div>
						</template> 
					</v-card>
				</v-flex>
				<v-flex xs12 sm6 >
					<v-card> 
						<template v-if="!isLoading">
							<v-toolbar color="teal" dark>
								<v-text-field flat solo-inverted hide-details prepend-inner-icon="search"
									v-model="filterTextKnowns" label="Ara" autocomplete="off" autocorrect="off"
									autocapitalize="off" spellcheck="false"></v-text-field>
							</v-toolbar>

							<v-list > 
								<template v-for="(item) in getItemsKnowns">
									<v-list-tile :key="item.user"   v-bind:class="{'expired' : item.days <= 30,'nonexpired' : item.days > 30,}">
										<v-list-tile-content>
											<v-list-tile-title> {{item.domain}} </v-list-tile-title>
										</v-list-tile-content>
										<v-list-tile-action>
											{{item.days}}  
										</v-list-tile-action>
									</v-list-tile>
								</template>
							</v-list>
						</template>
					</v-card>
				</v-flex>
				<v-flex xs12 sm6 >
					<v-card> 
						<template v-if="!isLoading">
							<v-toolbar color="white"  >
								<v-text-field flat solo-inverted hide-details prepend-inner-icon="search"
									v-model="filterTextUnknowns" label="Bilgi Alınamayanalar" autocomplete="off" autocorrect="off"
									autocapitalize="off" spellcheck="false"></v-text-field>
							</v-toolbar>

							<v-list > 
								<template v-for="(item) in getItemsUnknowns">
									<v-list-tile :key="item.user" avatar>
										<v-list-tile-content>
											<v-list-tile-title> {{item.domain}} </v-list-tile-title>
										</v-list-tile-content>
										<v-list-tile-action>
											<v-btn color="teal" icon ripple outline :loading="item.is_scanning" @click="scanItem(item)">
												<v-icon color="teal">replay</v-icon>
											</v-btn>
										</v-list-tile-action>
									</v-list-tile>
								</template>
							</v-list>
						</template>
					</v-card>
				</v-flex>
 



			</v-layout>
		</v-container>
	</v-content>


</template>


<script>
	export default {
		name: "ServerExpired",
		components: {},
		data: () => ({
			isLoading: true,
			filterTextKnowns: "",
			filterTextUnknowns: "",
			items_knowns: [],
			items_unknowns: [],
			item : {},
			dialogPlayStop : false,
		}),
		mounted() {
			this.loadItems();
		},
		methods: {
			loadItems() {
				this.isLoading = true;
				this.$http.get(process.env.VUE_APP_API_URL + "/server/domains/expired/", {
					params: {}
				}).then(response => { 
					this.items_knowns = response.body.knowns;
					this.items_unknowns = response.body.unknowns;
					this.isLoading = false;
				})
			}, 
			scanItem(item){
				item.is_scanning = true; 
				this.$http.get(process.env.VUE_APP_API_URL + "/server/domains/expired/scan", {
					params: {
						domain : item.domain
					}
				}).then(response => { 
					item.is_scanning = false; 
					if(response.body.success){
						this.loadItems();
					}
				})
			}
		},
		computed: {
			getItemsKnowns() {
				var items = [];
				var filterText = this.filterTextKnowns.toLowerCase();
				items = this.items_knowns.filter(function (item) {
					if (filterText != "") {
						if (item.domain.indexOf(filterText) < 0) {
							return false;
						}
					}
					return true;
				}) 
				return items;
			},
			getItemsUnknowns() {
				var items = [];
				var filterText = this.filterTextUnknowns.toLowerCase();
				items = this.items_unknowns.filter(function (item) {
					if (filterText != "") {
						if (item.domain.indexOf(filterText) < 0) {
							return false;
						}
					}
					return true;
				}) 
				return items;
			}
		}
	}
</script>



<style lang="less">
	.expired .v-list__tile__title{
		color : rgb(153, 0, 0) !important;
		font-weight: 700;
	}
	.expired .v-list__tile__action{
		color : rgb(153, 0, 0) !important;
		font-weight: 900;
	}
	.nonexpired .v-list__tile__title{
		color : rgb(0, 85, 7); 
	}
</style>
